<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>保证金账号：</span>
        <Input v-model="search.marginAccount" style="width:200px;"></Input>
      </div>
      <div class="search-item">
        <span>项目简编：</span>
        <Input v-model="search.numabbr" style="width:120px;"></Input>
      </div>
      <div class="search-item">
        <span>项目编号：</span>
        <Input v-model="search.fullnum" style="width:200px;"></Input>
      </div>
      <div class="search-item">
        <span>项目名称：</span>
        <Input v-model="search.projectName" style="width:200px;"></Input>
      </div>
      <div class="search-item">
        <span>筛选：</span>
        <Select v-model="search.hasRemit" style="width: 120px;">
          <Option :value="2">已有汇款</Option>
          <Option :value="1">未有汇款</Option>
          <Option :value="0">全部</Option>
        </Select>
      </div>
      <!-- <div class="search-item">
        <span>单位名称：</span>
        <Input v-model="search.supplierName" style="width:200px;"></Input>
      </div> -->
      <Button type="primary" @click="searchMargin" style="margin-right:10px;">搜索</Button>
      <Button type="primary" @click="refreshMargin" v-if="canRefresh">更新数据</Button>
    </div>
    <Table :columns="depositColumns" :data="depositList"></Table>
    <Page :total="pageTotal" :current="currentPage" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'depositProjectList',
  props: {
    operateColumns: {
      type: Array,
      default: () => {
        return []
      }
    },
    canRefresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      depositList: [],
      columns: [
        {
          title: '保证金账号',
          key: 'acctNo',
          width: 125,
        },
        {
          title: '项目名称',
          width: 250,
          render: (h, params) => {
            return h('div', params.row.clProjectDb.projectName)
          }
        },
        {
          title: '项目编号',
          width: 120,
          render: (h, params) => {
            return h('div', params.row.clProjectDb.projectFull)
          }
        },
      ],
      pageTotal: 0,
      currentPage: 1,
      search: {
        numabbr: '',
        fullnum: '',
        projectName: '',
        supplierName: '',
        marginAccount: '',
        hasRemit: ''
      },
    }
  },
  created() {
    this.getDepositList(1, this.search)
  },
  computed: {
    depositColumns() {
      return [...this.columns, ...this.operateColumns]
    }
  },
  methods: {
    async getDepositList(page, {numabbr = '', fullnum = '', projectName = '', supplierName = '', marginAccount = '', hasRemit = 0}) {
      this.currentPage = page

      let numabbrSear = numabbr ? ` and clProjectDb.projectShort.contains("${numabbr}")` : ''
      let fullnumSear = fullnum ? ` and clProjectDb.projectFull.contains("${fullnum}")` : ''
      let projectNameSear = projectName ? ` and clProjectDb.projectName.contains("${projectName}")` : ''
      let marginAccountSear = marginAccount ? ` and acctNo.contains("${marginAccount}")` : ''
      let hasRemitSear = hasRemit ? (hasRemit === 2 ? ' and clMargin.count > 0' : ' and clMargin.count == 0') : ''
      // let supplierNameSear = supplierName ? ` and reciprocalAccountName.contains("${supplierName}")` : ''

      let filter = numabbrSear + fullnumSear + projectNameSear + marginAccountSear + hasRemitSear

      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.ClMargin.GetMarginPaged, {
        params: {
          filter: filter,
          sorting: 'acctNo desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
        }
      })
      if (rep.data.success) {
        this.depositList = rep.data.result.items
        this.pageTotal = rep.data.result.totalCount
      }
    },
    pageChange(page) {
      this.getDepositList(page, this.search)
    },
    searchMargin() {
      this.getDepositList(1, this.search)
    },
    updateMarginData() {
      this.getDepositList(this.currentPage, this.search)
    },
    async refreshMargin() {
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.ClMargin.RefreshMargin)
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('刷新成功')
          this.getDepositList(1, this.search)
        } else {
          this.$Message.error('刷新失败')
        }
      } catch(err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('刷新失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  .search-item {
    margin-bottom: 5px;
    margin-right: 5px;
    display: inline-block;
  }
}
</style>
